import React from "react";

import "./Icon.scss";

const Icon = ({ at, alt, onClick }) => {
  return <img src={at} alt={alt} className="app-icon" onClick={onClick} />;
};

export default Icon;
